import { SYMBOLOGY_MAP, type Symbology } from "./formats";

/**
 * License entitlements applied client-side: the activation token may carry a
 * symbology whitelist (enterprise feature). Requests outside it are dropped
 * with a warning; server-side enforcement is the source of truth for billing.
 */

let allowed: Symbology[] | null = null;

export function setAllowedSymbologies(list: string[] | null): void {
  if (!list) {
    allowed = null;
    return;
  }
  allowed = list.filter((s): s is Symbology => s in SYMBOLOGY_MAP);
}

export function getAllowedSymbologies(): Symbology[] | null {
  return allowed;
}

export function filterAllowedSymbologies(requested: Symbology[]): Symbology[] {
  if (!allowed) return requested;
  const permitted = requested.filter((s) => allowed!.includes(s));
  if (permitted.length === requested.length) return requested;
  const dropped = requested.filter((s) => !allowed!.includes(s));
  console.warn(
    `[BarqScan] These symbologies are not covered by your license and were ignored: ${dropped.join(", ")}. ` +
      `Licensed symbologies: ${allowed.join(", ")}.`,
  );
  return permitted.length > 0 ? permitted : [...allowed];
}
